import React from 'react';
import { FormattedMessage } from 'react-intl';

import Box from './layout/Box';
import Button from './Button';
import Text from './Text';

const FullScreenError = ({ onRetry }) => {
  return (
    <Box className="flex-column align-items-center justify-content-center flex-grow-1 flex-shrink-1">
      <Text
        className="mb-2"
        style={{
          fontWeight: '600',
          fontSize: 20,
        }}
      >
        <FormattedMessage defaultMessage="Något gick fel!" />
      </Text>
      <Text
        className="mb-3"
        style={{
          maxWidth: 520,
          textAlign: 'center',
        }}
      >
        <FormattedMessage defaultMessage="Var god försök igen. Om felet skulle kvarstå, var god kontakta support på kontakt@kthbok.com." />
      </Text>
      <Button onClick={onRetry}>
        <FormattedMessage defaultMessage="Försök igen" />
      </Button>
    </Box>
  );
};

export default FullScreenError;
